import props from "./../../../src-utils/propDefiner";

export default {
  ...props("expiry", { type: [Number, String] }, "pm-countdown"),

  //Override Default Props
  ...props("display", { type: String, default: "flex" }),
  ...props("justify", { type: String, default: "center" }),
};
